import "./footer.css"

function Footer() {
  return (
    <div className="footer">
        <div className="flex flex-row items-center gap-2">
            <img src="/qrcodeMD.png" alt="MolthanaBakery" className="w-8 rounded-md" />
            <img src="/qrfacebook.png" alt="MolthanaBakery" className="w-8 rounded-md" />
            {/* <img src="/qrline.png" alt="MolthanaBakery" className="w-8 rounded-lg" /> */}
            <span>มลธนา เบเกอรี่</span>
        </div>
        <span>© freelance Dev</span>
    </div>
    )
}

export default Footer